import React from 'react'; 
import Background from '../../../components/patientApp/background/background'
import ComplaintSubmit from '../../../components/patientApp/patientChat/complaintsubmit/complaintsubmt';

const SubmitChat = () => {
    return <Background>
        <ComplaintSubmit />
    </Background>
}
export default SubmitChat;